<template>
	<div>
		<FlexiblePaymentCondition
			v-if="showFlexible"
			:displayTitle="props.displayTitle"
			:prestId="props.prestId"
			:isPVFlex="isPVFlexProduct"
			:isDisplayPlaceholders="props.isDisplayPlaceholders"
			:content="store.state.content"
			:cancellationDate="props.cancellationDate"
			:startDate="startDate" 
			:isCompactDisplay="props.isCompactDisplay"
			/>

		<FixedPaymentCondition
			v-else
			:displayTitle="props.displayTitle"
			:prestId="props.prestId"
			:isDisplayPlaceholders="props.isDisplayPlaceholders"
			:content="store.state.content" 
			:isCompactDisplay="props.isCompactDisplay"
			/>
	</div>
</template>

<script setup lang="ts">
import { defineProps, computed, ComputedRef } from "vue"

// Enums
import { PaymentCondition } from "@/enums/paymentCondition"

// Components
import FlexiblePaymentCondition from "./FlexiblePaymentCondition.vue"
import FixedPaymentCondition from "./FixedPaymentCondition.vue"

import { useStore } from "vuex"
const store = useStore();

// Props
interface Props {
	paymentCondition: number
	displayTitle: boolean
	cancellationDate: string
	/** PV only: "flex" | "nonflex". Absent for non-PV → use paymentCondition. */
	pvFlex?: string
	prestId?: string
	isDisplayPlaceholders?: boolean
	isCompactDisplay?: boolean
}

const props = defineProps<Props>()

// Computed
const startDate: ComputedRef<string> = computed(() => {
	return store.state.dates.BeginDate || ""
})

const isPVFlexProduct: ComputedRef<boolean> = computed(() => {
	return props.pvFlex === "flex"
})

// PV: FLEX/FIXE comes from pvFlex (API often sends paymentCondition=2 for both).
// Non-PV: use paymentCondition (1 = FLEX, 2 = FIXE).
const showFlexible: ComputedRef<boolean> = computed(() => {
	if (props.pvFlex === "flex") return true
	if (props.pvFlex === "nonflex") return false
	return props.paymentCondition === PaymentCondition.FLEXIBLE
})
</script>
